<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import { getHubStores } from '$lib/stores/hubStores';
	import SigninModal from './signinModal.svelte';
	import AuxModal from '$lib/Signin/auxModals/AuxModal.svelte';
	import { email } from './emailStore';

	const { user } = getHubStores();

	const isUserLoggedIn = $user && parseInt($user.id, 10) > 0;

	let isResetPasswordFormDisplayed = false;
	let isJoinCommunityFormDisplayed = false;
	let isSparqAdminInfoModalDisplayed = false;

	enum AUXTypes {
		PasswordReset = 'password-reset',
		PasswordResetCompleted = 'password-reset-completed',
		EmailVerified = 'email-verified',
		AccountUnlocked = 'account_unlocked',
		SSOError = 'sso-error',
		SAMLError = 'saml-error',
		Joined = 'joined',
		AccountVerified = 'account-verified',
	}

	let isAUXModalRendered = $page.url.searchParams.has('aux');
	const isTokenInvalid = $page.url.searchParams.has('err');
	let auxType: string | null = null;
	let token = '';

	if (isAUXModalRendered) {
		const searchParams = $page.url.searchParams;

		// parse the aux parameter from such urls "https://myURL/hubId?aaa=bbb&aux=password-reset&ccc=ddd"
		auxType = searchParams.get('aux');

		if (searchParams.has('hash')) {
			token = searchParams.get('hash') || '';
		}

		// remove the query parameters, e.g. from "https://myURL/hubId?aaa=bbb&aux=password-reset&ccc=ddd" to "https://myURL/hubId"
		if (browser) {
			window.history.replaceState({}, $page.url.href, $page.url.href.split('?')[0]);
		}
	}
	const isAlreadyMember = $page.url.searchParams.has('alreadyMember');

	if (isAlreadyMember) {
		$email = $page.url.searchParams.get('alreadyMember') ?? '';
	}

	const isCCPAPageRendered = $page.url.href.includes('compliance/ccpa');
</script>

<!-- CCPA Opt-out page should be rendered without having a session as well -->
{#if isUserLoggedIn || isCCPAPageRendered}
	<slot />
{:else if !isAUXModalRendered || (isAUXModalRendered && auxType !== AUXTypes.PasswordReset)}
	<SigninModal
		{isResetPasswordFormDisplayed}
		{isJoinCommunityFormDisplayed}
		{isSparqAdminInfoModalDisplayed}
		{isAlreadyMember}
	/>
{/if}
{#if isAUXModalRendered && auxType}
	<AuxModal
		{token}
		{auxType}
		bind:isResetPasswordFormDisplayed
		bind:isAUXModalRendered
		{isTokenInvalid}
	/>
{/if}
